import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuService } from '../../../../services/menu.service';
import { MenuNode } from '../../../../classes/MenuNode';
import { TranslationService } from '../../../../services/translation.service';
import { TextdisplayComponent } from '../../../helpers/textdisplay/textdisplay.component';
@Component({
    selector: 'app-control-showcase',
    templateUrl: './control-showcase.component.html',
    styleUrls: ['./control-showcase.component.scss'],
    standalone: false
})
export class ControlShowcaseComponent implements OnInit,OnDestroy {

  title:string;
  node:MenuNode;
  _texts:Array<string>;
	get text(){
		return this._texts;
	}

  constructor(private ioService:DataIoService, private menuService: MenuService,private translator: TranslationService) { 
  	this.parameters=new Array<string>();
  }

  eventHandler(event){
    console.log("Got Event:"+event);
  	if(event == "confirm"){
  		if(this.menuService.hasNextMenuItem()){
  			this.menuService.selectNextMenuItem();
  		}else{
  			this.menuService.hierarchyUp();
  		}
  		return;
  	}
  	if(this.parameters.includes(event)){
  		this.eventHandler('confirm');
  		return;
  	}
  	if(event == "back"){
      console.log("Got back event on "+this.menuService.getCurrentNode().getIdentifier());
      switch(this.menuService.getCurrentNode().getIdentifier()){
        case 'controlshowcase-1':
        case 'serialnummer':
        case 'controlshowcase_plain-1':
        case 'fault-list':
        case 'controlshowcase-wizard-1':{
          console.log("Trying to go back...");
          if(this.menuService.getCurrentNode().hasBackTarget()){
            let backTarget = this.menuService.goto(this.menuService.getCurrentNode().getBackTargetNode());
            return;
          }
          if(this.menuService.hasPreviousMenuItem()){
            this.menuService.selectPreviousMenuItem();
          }else{
            this.menuService.hierarchyUp();
          }
        }
        default:{
          return;
        }
      }
      if(this.menuService.hasPreviousMenuItem()){
  		  this.menuService.selectPreviousMenuItem();
      }else{
        this.menuService.hierarchyUp();
      }
  		return;
  	}

  }

  parameters:Array<string>;
	eventSubscription:any;
	ngOnInit() {
		this.parameters = this.menuService.getCurrentNode().getTemplateParameters();
		this.title = this.menuService.getCurrentNode().getTitle();
		this.node = this.menuService.getCurrentNode();
    this._texts = this.node.getTexts();
    this.eventSubscription = this.ioService.inputs.events$.subscribe(

			(event)=>{
				this.eventHandler(event);
			});
	}
	ngOnDestroy(){
		if(this.eventSubscription){
			this.eventSubscription.unsubscribe();
		}
	}

}
